<script lang="ts">
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import * as Select from "$lib/components/ui/select/index.js";

  import { type MonetaryUnit, monetaryUnits } from "@briefmarken_katalog/types"
  import { t, locale } from "$lib/i18n";

  let { value = $bindable(), unit = $bindable(), isReadonly = false, invalidAmount = false, invalidUnit = false }: { value: number, unit: MonetaryUnit | undefined, isReadonly?: boolean, invalidAmount?: boolean, invalidUnit?: boolean } = $props();

  const triggerValue_MonetaryUnit = $derived(
    monetaryUnits.find((v: string) => v === unit) ?? $t('fields.selectUnit')
  );

  function format(n: number): string {
    return n != null ? n.toLocaleString($locale) : '';
  }

  let isEditing = $state(false);
  let displayValue = $state(format(value));

  $effect(() => {
    if (!isEditing) {
      displayValue = format(value);
    }
  });

</script>

<div class="grid grid-cols-4 items-center gap-4">
    <Label for="amount" class="text-right">{$t('fields.faceValue')}</Label>
    <div class="flex gap-2 col-span-3">
        <Input
            readonly={isReadonly}
            id="amount"
            type="text"
            inputmode="decimal"
            value={displayValue}
            placeholder={$t('fields.faceValuePlaceholder')}
            aria-invalid={invalidAmount ? "true" : undefined}
            class="w-24"
            onfocus={() => {
              isEditing = true;
              displayValue = value != null ? String(value) : '';
            }}
            oninput={(e) => {
              const el = e.target as HTMLInputElement;
              const digits = el.value.replace(/[^\d.]/g, '');
              el.value = digits;
              value = digits === '' ? 0 : Number(digits);
            }}
            onblur={() => {
              isEditing = false;
              displayValue = format(value);
            }}
        />
{#if isReadonly}
        <div class="p-2 border rounded">{unit}</div>
{:else}
        <Select.Root
            type="single"
            name="face_value_unit"
            bind:value={unit}
        >
            <Select.Trigger class="w-[180px]" aria-invalid={invalidUnit ? "true" : undefined}>
                {triggerValue_MonetaryUnit}
            </Select.Trigger>
            <Select.Content>
                <Select.Group>
                    <Select.Label>{$t('fields.unit')}</Select.Label>
                    {#each monetaryUnits as unit}
                        <Select.Item value={unit} label={unit}>
                            {unit}
                        </Select.Item>
                    {/each}
                </Select.Group>
            </Select.Content>
        </Select.Root>
{/if}
    </div>
</div>
